import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslationsService } from '../translations.service';
import { ImportTranslationError, ImportTranslationResponse, ImportTranslationSuccess, ImportTranslationType } from '../translations.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-translations-import-modal',
    templateUrl: './translations-import-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './translations-import-modal.component.scss'
})
export class TranslationsImportModalComponent implements OnInit {
  @Input() date: string = '';

  importCount: number = 0;
  deleteCount: number = 0;

  loadingImports: boolean = true;
  loadingDeletions: boolean = true;
  awaitingResponse: boolean = false;

  result: ImportTranslationResponse | null = null;
  error: string = '';
  successMessage: string = '';

  imports: ImportTranslationSuccess[] = [];
  importErrors: ImportTranslationError[] = [];
  deletions: ImportTranslationSuccess[] = [];
  deletionErrors: ImportTranslationError[] = [];

  constructor(public activeModal: NgbActiveModal,
    public translation: TranslationsService) { }

  async ngOnInit(): Promise<void> {
    const loadingDelay = this.sleep(600);
    //get count
    const importCountPromise = this.translation.getImportCount().then(count => {
      this.importCount = count;
    });

    const deleteCountPromise = this.translation.getDeleteCount().then(count => {
      this.deleteCount = count;
    });

    // Wait for both the counts and the minimum time to complete
    await Promise.all([loadingDelay, importCountPromise, deleteCountPromise]);

    this.loadingImports = false;
    this.loadingDeletions = false;
  }

  async sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async importTranslations() {
    try {
      this.awaitingResponse = true;
      this.error = '';
      this.result = await this.translation.importTranslations();

      // Calculate success message from counts
      const addedCount = this.importCount;
      const deletedCount = this.deleteCount;
      this.successMessage = `Success, tilføjede ${addedCount} og fjernede ${deletedCount} antal rækker`;

      // Update date
      const newDate = new Date();
      this.date = newDate
        ? `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`
        : '';
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        // Extract error message from BusinessException response
        const errorMessage = error.error?.message || error.message || 'Ukendt fejl';
        this.error = `Error with exception: ${errorMessage}`;
        console.error('Import error:', error);
      }
    } finally {
      this.awaitingResponse = false;
    }
  }

  accept(reason: string) {
    this.activeModal.close(reason);
  }
}
